import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useSelect as useCoins } from '@/pages/coin/api';
import React from 'react';
export const SelectCoin = ({
  value,
  onChange,
  placeholder = '全部',
  useName = false,
  addThird = false,
  ...rest
}) => {
  const {
    data,
    isLoading
  } = useCoins({
    params: {
      pageSize: 100,
      pageIndex: 1
    }
  });
  const options = data ? data.data.items.map(v => ({
    label: `${v.name}-${v.display_name}`,
    value: useName ? v.name : v.id
  })) : [];

  if (addThird) {
    options.push(...[{
      label: '三方支付',
      value: 'THIRD'
    }, {
      label: '银行卡支付',
      value: 'CARD'
    }]);
  }

  return /*#__PURE__*/React.createElement(_Select, _extends({
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    loading: isLoading
  }, rest, {
    options: options,
    allowClear: true
  }));
};